import React from 'react';

// import components
import AlternatingImageContentRows, { CardProps } from 'components/partials/alternating-image-content-rows';

// import helpers
import { isGatsbyImageData } from "helpers/is-gatsby-image";
import { getLinkDataFromDato } from "helpers/get-link-data";

const ImageContentRowCollectionBuilder: React.FC<{ imageContentRowCollection?: Queries.ImageContentRowCollectionBlockFragment }> = ({ imageContentRowCollection }) => {

    if (!imageContentRowCollection) return null;

    const cards: CardProps[] = imageContentRowCollection.imageContentRows?.map((row) => {
        if (!row) return undefined;

        let image = undefined;

        if (row.image && typeof row.image === 'object') {
            image = isGatsbyImageData(row.image.gatsbyImageData) ? row.image.gatsbyImageData : undefined;
        }

        let primaryButton = undefined;

        if (row.link && typeof row.link === 'object') {

            let linkData = getLinkDataFromDato(row.link?.link);

            let linkLabel = linkData?.label || 'Error: Missing label';

            if (linkData?.title) {
                linkLabel = linkData.title;
            }

            primaryButton = {
                buttonText: linkLabel,
                buttonUrl: linkData?.url || '',
                target: linkData?.target || '_self',
            };
        }

        return {
            gatsbyImageData: image,
            headline: row.heading || 'Error: Missing headline',
            htmlContent: row.text || '',
            primaryButtonProps: primaryButton,
        };

    }).filter(card => card !== undefined) as CardProps[] || [];

    return <AlternatingImageContentRows cards={cards} />;
};

export default ImageContentRowCollectionBuilder;